import { render, staticRenderFns } from "./InsuranceCompanyModal.vue?vue&type=template&id=150bd33c&"
import script from "./InsuranceCompanyModal.vue?vue&type=script&lang=js&"
export * from "./InsuranceCompanyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports